import {z} from 'zod';
import {requestParamsValidator} from './presentation/requestParameter';

export const presentationValidator = z.object({
    requestParams: z.array(requestParamsValidator),
});
